import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "text-caption text-grey" }
const _hoisted_3 = { class: "pl-4" }
const _hoisted_4 = ["href", "onClick"]
const _hoisted_5 = { class: "text-grey" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "mb-1" }
const _hoisted_9 = { class: "text-caption text-grey" }
const _hoisted_10 = { class: "pl-4" }
const _hoisted_11 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_dialog_loading = _resolveComponent("ontos-dialog-loading")!
  const _component_ontos_page_header = _resolveComponent("ontos-page-header")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_ontos_hidden_count = _resolveComponent("ontos-hidden-count")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_ontos_dialog = _resolveComponent("ontos-dialog")!

  return (_openBlock(), _createBlock(_component_ontos_dialog, {
    "model-value": true,
    "max-width": "620px",
    persistent: _ctx.loaded,
    "onUpdate:modelValue": _ctx.onDialogInput
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          (!_ctx.loaded)
            ? (_openBlock(), _createBlock(_component_ontos_dialog_loading, {
                key: 0,
                "min-height": "160px"
              }))
            : (_ctx.blocked)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ontos_page_header, {
                        title: _ctx.$tt('delete.blocked-title'),
                        level: 2
                      }, null, 8, ["title"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("p", {
                        innerHTML: _ctx.$tt('delete.blocked-intro', {name: _ctx.identifier})
                      }, null, 8, _hoisted_1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blockers, (edge, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "mb-3"
                        }, [
                          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$tt('delete.link-line', {collection: edge.ideaName, property: edge.propertyName})), 1),
                          _createElementVNode("ul", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(edge.instances, (item) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: item._instance
                              }, [
                                _createElementVNode("a", {
                                  href: _ctx.hrefFor(edge, item),
                                  onClick: ($event: any) => (_ctx.onBlockerClick($event, edge, item))
                                }, _toDisplayString(item._identifier), 9, _hoisted_4),
                                _createElementVNode("span", _hoisted_5, " — " + _toDisplayString(_ctx.reasonText(edge, item)), 1)
                              ]))
                            }), 128)),
                            (edge.hidden)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                                  _createVNode(_component_ontos_hidden_count, {
                                    count: edge.hidden
                                  }, null, 8, ["count"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, {
                    justify: "end",
                    class: "mt-0 pt-0 pa-5",
                    "no-gutters": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "auto" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            size: "small",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closed')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                size: "small",
                                start: ""
                              }, {
                                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                  _createTextVNode("mdi-close", -1)
                                ]))]),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$tt('close')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ontos_page_header, {
                        title: _ctx.$tt('delete.title', {collection: _ctx.ideaName}),
                        level: 2
                      }, null, 8, ["title"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("p", {
                        innerHTML: _ctx.$tt('delete.message', {name: _ctx.identifier})
                      }, null, 8, _hoisted_7),
                      (_ctx.links.length)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$tt('delete.links-intro')), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (edge, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "mb-2"
                              }, [
                                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$tt('delete.link-line', {collection: edge.ideaName, property: edge.propertyName})), 1),
                                _createElementVNode("ul", _hoisted_10, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(edge.instances, (item) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: item._instance
                                    }, _toDisplayString(item._identifier), 1))
                                  }), 128)),
                                  (edge.hidden)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                                        _createVNode(_component_ontos_hidden_count, {
                                          count: edge.hidden
                                        }, null, 8, ["count"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128))
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, {
                    justify: "end",
                    class: "mt-0 pt-0 pa-5",
                    "no-gutters": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "auto" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            size: "small",
                            color: "error",
                            onClick: _ctx.confirm
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                size: "small",
                                start: ""
                              }, {
                                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                  _createTextVNode("mdi-delete", -1)
                                ]))]),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$tt('delete.confirm')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "auto",
                        class: "pl-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            size: "small",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closed')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                size: "small",
                                start: ""
                              }, {
                                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                  _createTextVNode("mdi-cancel", -1)
                                ]))]),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$tt('cancel')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 64))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["persistent", "onUpdate:modelValue"]))
}